import {trackedPlayers, killfeed} from ".";

export function getTrackedPlayerIds(wipeIndex: number)
{
    return trackedPlayers[wipeIndex].map(({name}) => killfeed.playerNames.indexOf(name));
}

export function getTrackedPlayerColorsById(trackedPlayerIds: number[], wipeIndex: number)
{
    const colorsById: Record<number, string> = {};
    trackedPlayerIds.forEach((id, i) => colorsById[id] = trackedPlayers[wipeIndex][i].color);
    return colorsById;
}
